// This component is used to display a popover when the user tries to access a feature that is available only after registration.
function Popover() {
  return (
    <>
      <div className="popover">
        This feature is available after free registration.
        <a href="/auth"> Sign Up</a>
      </div>
    </>
  );
}

export default Popover;
